import { css } from 'styled-components';
import { colors } from '../utils/colors';

export type InputStyleProps = { $error?: boolean };

export const InputStyle = css<InputStyleProps>`
    border: 2px solid
        ${(props): string => (props.$error ? colors.red600 : colors.gray900)};
    padding: 10px 14px;
    font-size: 16px;
    line-height: 24px;
    border-radius: 8px;
    width: 100%;
    &:not(:disabled) {
        &:focus {
            outline: 2px solid
                ${(props): string =>
                    props.$error ? colors.red600 : colors.indigo400};
            border-color: ${colors.indigo400};
        }
    }
    &:disabled {
        border-color: ${colors.gray400};
        background-color: ${colors.gray100};
        color: ${colors.gray400};
    }
`;
